module.exports = __webpack_public_path__ + "media/images/flags/BJ-cfdd2015e502a87800ba073b89fd39dc.svg";